import React from "react";
import * as c from "./landingPages.module.scss";
import classNames from "classnames";
import { getLandingPageSections } from "@templates/landingPages/landingPageSections";
import Layout from "@components/layout";
import { FeaturePageHeader } from "@components/pages/landingPages/featurePageHeader";
import PaymentsRateSection from "@components/pages/payments/paymentsRateSection";

const FeaturePage = ({ contentfulLandingPage }) => {
  const { pageHeader, actionSections, sections, contentful_id } = contentfulLandingPage;
  const isPaymentsPage = contentful_id === "731HawyDVWdLEhoZwpZ8Yp";
  const { sectionComponents, actionSectionsComponents } = getLandingPageSections({
    sections,
    actionSections,
    className: c,
  });

  return (
    <Layout className={classNames(c.pageWrapper, "cream-100")}>
      <FeaturePageHeader className={c.pageHeader} pageHeaderData={pageHeader} />

      <div className={c.sections}>
        {sectionComponents}

        {isPaymentsPage && <PaymentsRateSection />}

        {actionSectionsComponents}
      </div>
    </Layout>
  );
};

export default FeaturePage;
